import { SmartRedirect } from "@components:SmartRedirect";
import { useUser } from "@libs:react-query-auth";
import { Navigate } from "react-router";

import { Routes } from "@:constants";

export const Root = () => {
  const user = useUser();

  return <>{user.data ? <SmartRedirect /> : <Navigate to={Routes.Login} />}</>;
};
